<template>
  <section id="store_container">
    <fieldset class="fieldset">
      <legend>Validar</legend>
      <div class="columns">
        <div class="column">
          <b-field label="Empresa *">
            <Treeselect
                :options="companies"
                :show-count="true"
                v-model="company"
                name="company"
                v-validate="'required'"
                placeholder="Seleccione una empresa"
            />
          </b-field>
          <span class="show-error">{{ errors.first("company") }}</span>
        </div>
        <div class="column">
          <b-field label=" Fecha Desde">
            <b-datepicker
                v-validate="'required'"
                v-model="dateInitial"
                placeholder="Seleccione una fecha..."
                icon="calendar-today"
                name="dateInitial"
                :max-date="new Date()"
            >
            </b-datepicker>
          </b-field>
          <span class="show-error">{{ errors.first("dateInitial") }}</span>
        </div>
        <div class="column">
          <b-field label=" Fecha Hasta">
            <b-datepicker
                v-validate="'required'"
                v-model="dateFinal"
                placeholder="Seleccione una fecha..."
                icon="calendar-today"
                name="dateFinal"
                :min-date="dateRangeMin"
                :max-date="dateRangeMax"
            >
            </b-datepicker>
          </b-field>
          <span class="show-error">{{ errors.first("dateFinal") }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <b-field label="Tipo vehículo">
            <multiselect v-model="valueTypeVehicle"
                         :options="vehicles"
                         :multiple="true"
                         group-values="typeVehicle"
                         group-label="selectAll"
                         :group-select="true"
                         placeholder="Buscar tipo de vehículo"
                         track-by="code"
                         label="name"
                         name="idsType"
                         v-validate="'required'"></multiselect>
          </b-field>
          <span class="show-error">{{ errors.first("idsType") }}</span>
        </div>
        <div class="column is-4">
          <b-field label="Unidad de tiempo">
            <b-select
                placeholder="Seleccione una unidad de tiempo"
                expanded
                v-model="selectUnityTime"
                v-validate="'required'"
                name="type">
              <option
                  v-for="option in timeList"
                  :value="option"
                  :key="option.code">{{ option.name }}
              </option>
            </b-select>
          </b-field>
          <span class="show-error">{{ errors.first("type") }}</span>
        </div>
        <div class="column is-4">

          <b-field label="Filtros">
            <multiselect v-model="valueTypeMonthly"
                         :options="typeMonthly"
                         :multiple="true"
                         group-values="typeMonthly"
                         group-label="selectAll"
                         :group-select="true"
                         placeholder="Buscar un filtro"
                         track-by="code"
                         label="name"></multiselect>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="buttons button-group">
            <b-button color="dark" @click="searchForm()" type="is-info"> Buscar</b-button>
            <b-button @click="download()" type="is-info" label="Descargar"/>
          </div>
        </div>
      </div>

    </fieldset>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import {configToast, TOAST_TYPES} from "@/global/toast";
import {ROUTES} from "@/global/api_routes";
import DateUtils, {FORMATS} from "@/global/DateUtils";
import Treeselect from "@riophae/vue-treeselect";
import Multiselect from "vue-multiselect";

export default {
  name: "generic-movement",
  data: () => ({
    isLoading: false,
    companies: [],
    company: null,
    dateInitial: null,
    dateFinal: null,
    dateMax: new Date(),
    dateMin: new Date(),
    valueTypeVehicle: [],
    vehicles: [],
    selectUnityTime: null,
    valueTypeMonthly: [],
    typeMonthly: [],
    timeList: [{code: 1, name: "15 Minutos", nickname: "15 MINUTE", minute: 15},
      {code: 2, name: "30 Minutos", nickname: "30 MINUTE", minute: 30},
      {code: 3, name: "1 Hora", nickname: "60 MINUTE", minute: 60},
      {code: 4, name: "2 Horas", nickname: "120 MINUTE", minute: 120},
      {code: 5, name: "4 Horas", nickname: "240 MINUTE", minute: 240}],
  }),
  mounted() {
    this.getCompanies();
    this.getVehicleTypes();
    this.getTypes();
  },

  computed: {

    dateRangeMax() {
      const dateActually = new Date();
      if (this.dateInitial !== null) {
        this.dateFinal = this.dateInitial;
        this.dateMin = this.dateInitial;
      }
      this.dateMax = new Date(this.dateMin.getFullYear(), this.dateMin.getMonth(), this.dateMin.getDate() + 62);
      if (this.dateMax > dateActually) {
        return this.dateMax = dateActually;
      }
      return this.dateMax;
    },

    dateRangeMin() {
      return this.dateMin;
    }

  },

  methods: {

    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#subscription_container");
      return instance.open(message, type);
    },

    getCompanies() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.GET_COMPANIES_TREE)
          .then(({data}) => {
            if (data.code > 0) {
              this.companies = data.info;
              this.processData(this.companies);
              this.isLoading = false;
            }
          })
    },

    processData(companiesEntry) {
      for (let index = 0; index < companiesEntry.length; index++) {
        let companies = companiesEntry[index];
        companies.label = companies.name;
        companies.id = companies.code;
        if (companies.children) {
          this.processData(companies.children);
        }
      }
    },
    getTypes() {
      this.$http
          .get(ROUTES.DASHBOARD.ENTITY.GET_LIST_BY_KIND, {
            params: {
              kindId: 21,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              data.info.push({
                code: 1,
                title: "Rotativo"
              });
              this.toast(data.message, TOAST_TYPES.SUCCESS);
              const entityBuild = {
                selectAll: 'Seleccionar Todo',
                typeMonthly: data.info.map(vehicle => {
                  return {
                    name: vehicle.title,
                    code: vehicle.code
                  }
                })
              };
              this.typeMonthly.push(entityBuild);
            }
          });
    },

    getVehicleTypes() {
      this.$http.get(ROUTES.DASHBOARD.GET_VEHICLE_TYPES).then(({data}) => {
        if (data.code <= 0) {
          this.toast(data.message, TOAST_TYPES.ERROR);
          return;
        }
        this.toast(data.message, TOAST_TYPES.SUCCESS);
        const entityBuild = {
          selectAll: 'Seleccionar Todo',
          typeVehicle: data.info.map(vehicle => {
            return {
              name: vehicle.title,
              code: vehicle.code
            }
          })
        };
        this.vehicles.push(entityBuild);
      });
    },

    async searchForm() {
      const validationResult = await this.$validator.validateAll();
      if (validationResult === false) {
        this.toast('Debe Completar el formulario', TOAST_TYPES.ERROR);
        return;
      }
      const validDates = DateUtils.isBefore({before: this.dateFinal, date: this.dateInitial})
      if (validDates) {
        this.toast('La fecha final no puede ser inferior a fecha inicial', TOAST_TYPES.ERROR);
        return;
      }
      this.isLoading = true;
      this.toast('Cargando información de la tabla', TOAST_TYPES.SUCCESS);
      const params = {
        date_initial: DateUtils.toDateShortString({date: this.dateInitial, format: "YYYY-MM-DD HH:mm:ss"}),
        date_final: DateUtils.toDateShortString({date: this.dateFinal, format: "YYYY-MM-DD HH:mm:ss"}),
        time_range: this.selectUnityTime.nickname,
        id_company: this.company,
        type_vehicle: this.valueTypeVehicle,
        type_report: "xlsx",
        filter: this.valueTypeMonthly
      };
      this.$http
          .post(this.routerSearch, params)
          .then(data => {
            if (data.data.info !== null) {
              this.$emit('minute', this.selectUnityTime.minute);
              this.$emit('data', data.data.info);
              this.isLoading = false;
              return;
            }
            this.isLoading = false;
            this.toast('No hay información de la tabla', TOAST_TYPES.ERROR);
          });

    },

    async download() {
      const validationResult = await this.$validator.validateAll();
      if (validationResult === false) {
        this.toast('Debe Completar el formulario', TOAST_TYPES.ERROR);
        return;
      }
      const validDates = DateUtils.isBefore({before: this.dateFinal, date: this.dateInitial})
      if (validDates) {
        this.toast('La fecha final no puede ser inferior a fecha inicial', TOAST_TYPES.ERROR);
        return;
      }
      this.isLoading = true;
      this.toast('Cargando Reporte', TOAST_TYPES.SUCCESS);
      const params = {
        date_initial: DateUtils.toDateShortString({date: this.dateInitial, format: "YYYY-MM-DD HH:mm:ss"}),
        date_final: DateUtils.toDateShortString({date: this.dateFinal, format: "YYYY-MM-DD HH:mm:ss"}),
        time_range: this.selectUnityTime.nickname,
        id_company: this.company,
        type_vehicle: this.valueTypeVehicle,
        type_report: "xlsx",
        filter: this.valueTypeMonthly
      };
      this.$http
          .post(this.routerDownload, params)
          .then(({data}) => {
            if (data.code < 0) {
              this.toast(data.message, TOAST_TYPES.ERROR);
              return;
            }
            this.isLoading = false;
            this.$emit('download', data);
          });
    }

  },
  props: {
    routerSearch: {
      type: String
    },
    routerDownload: {
      type: String
    }
  },
  components: {
    Treeselect, Multiselect,
  }

}
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css">

</style>
